import { ShowVisitButton } from './ShowVisitButton';

type OptionsCellProps = {
   readonly visitId: number | undefined;
   readonly patientId: number;
};

export const OptionsCell = (props: OptionsCellProps): JSX.Element => {
   return <ShowVisitButton visitId={props.visitId} patientId={props.patientId} />;
};
